import { Component, Input, OnChanges } from '@angular/core';
import { CreateAlertComponent } from '../create-alert/create-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { CustomerAlertsService } from 'src/app/services/customer-alerts.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { CUSTOMER_TYPE_FAILURE_MSG, SAVE_ALERT_FAILURE_MSG } from '../../../models/Constants';
import _ from 'lodash';

@Component({
  selector: 'app-display-alert',
  templateUrl: './display-alert.component.html',
  styleUrls: ['./display-alert.component.scss']
})
export class DisplayAlertComponent implements OnChanges {

  @Input() id: any;
  @Input() newAlert: boolean = false;
  @Input() newAlertId: string = '';
  @Input() refreshAlertList: boolean = false;
  displaySaveAlertErrMsg: boolean = false;
  saveAlertFailMsg = SAVE_ALERT_FAILURE_MSG;
  showLoader: boolean = false;
  loaderType = Constants.LOADER_TYPE.CARD;
  isAlertListAPIError: boolean = false;
  alertList: any = [];
  alertListErrMsg = CUSTOMER_TYPE_FAILURE_MSG;
  showExpiredAlert: boolean = false;
  showDeleteAlert: boolean = false;
  iconConfig: any;
  showLockedAlertMsg :boolean = false;
  noOfLockedAlerts :any;
  @Input() loadingFromWrapUpPage: boolean = false;
  @Input() isLiveCall :boolean = false;

  constructor(public apiService: ApiService,
    public dialog: MatDialog,
    public rootScope: RootScopeService,
    public custAlertsService: CustomerAlertsService) {
    //this.checkData();

    this.iconConfig = {
      iconName: 'circle-plus',
      iconType: 'solid',
      iconPlacement: 'right',
    };
    this.custAlertsService.refreshAlerts.subscribe({
      next: (res: boolean) => {
        if (res &&   this.custAlertsService.refreshedClicked) { this.getAllAlerts(); 
          this.custAlertsService.refreshedClicked=false;
        }
      },
      error: (err: string) => { console.log(err) }
    })
  }

 

  /** 
   * ngOnChanges -- checking update, in case of tab change & creating new alert .
   * @author :Amarjeet Kumar
   */
  ngOnChanges(changes) {
    if ((changes?.id?.currentValue != changes?.id?.previousValue )|| (changes?.isLiveCall?.currentValue != changes?.isLiveCall?.previousValue)) {
      this.checkData();
    }
    if(changes?.refreshAlertList?.currentValue){
      this.getAllAlerts();
    }
    if (changes?.newAlert?.currentValue) {
      this.getAllAlerts();
    }
  }


  deleteAlert(eachAlert) {
    eachAlert.disableDelete = true;
    eachAlert.showDeleteAlert = true;
  }

  closeDeleteAlert(eachAlert) {
    eachAlert['displaySaveAlertErrMsg'] = false;
    eachAlert.showDeleteAlert = false;
    eachAlert.disableDelete = false;
  }


  /**
   * below methods perform delete activity and update UI accordingly
   * @param eachAlert 
   */
  performDelete(eachAlert) {
    let that = this;
    eachAlert['displaySaveAlertErrMsg'] = false;
    this.apiService.deleteAlert(eachAlert.runtimeAlertId)
      .subscribe({
        next: (data: any) => {
          
          if(data){
          that.closeDeleteAlert(eachAlert);
          this.alertList = _.filter(this.alertList, function (currentObject) {
            return currentObject.runtimeAlertId != eachAlert.runtimeAlertId;
          })
          this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].data = this.alertList

        }},
        error: (error) => {
          this.saveAlertFailMsg = Constants.ALERT_DELETE_MSG;
          eachAlert['displaySaveAlertErrMsg'] = true;
        }
      })
  }


  /** 
* checkData -- checking for cached data.
* @author :Amarjeet Kumar
*/
  checkData() {
    if (this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]) {
      this.alertList = this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.data;
      if (this.loadingFromWrapUpPage) {
        this.alertList = _.filter(this.alertList, function (currentObject) {
          return currentObject.isReviwed != true;
        })
      }
      this.filterAlertListIfLocked();
    }
    else {
      this.getAllAlerts();
    }
  }



  /** 
 * getAllAlerts() -- calling API to get all alerts list.
 * @author :Amarjeet Kumar
 */
  getAllAlerts() {
    this.showLoader = true;
    this.rootScope.refreshAlertList = false;
    this.apiService.getAlertList()
      .subscribe({
        next: (data: any) => {
          data?.data.map(function (each) {
            let clonedObj = Object.assign({}, each);
            each['editTitle'] = clonedObj.headline;
            each['editDesc'] = clonedObj.detail;
            each['showContent1'] = true;
            each['isOpen'] = false;
          })



          if (this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId] && this.newAlertId) {
            let newAlert = data.data.filter(x => x.runtimeAlertId == this.newAlertId)
            let cloneData = [...newAlert, ...this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].data]
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].data = cloneData;
           
              this.alertList = cloneData;
          }
          else {
            this.alertList = data.data.sort((a, b) => (new Date(b.created) as any) - (new Date(a.created) as any));
            if (this.loadingFromWrapUpPage) {
              this.alertList = _.filter(this.alertList, function (currentObject) {
                return currentObject.isReviwed != true;
              })
            }
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId] = data;
          }

          // this.rootScope.alertData = data?.data
          this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].isAPIError = false;
          this.rootScope.isAlertAdded = false;
          this.rootScope.newAlertId = '';
          this.filterAlertListIfLocked()
          this.showLoader = false;
        },
        error: (error) => {

          this.showLoader = false;
          if (error?.error?.message == Constants.NO_DATA_FOUND) {
            this.alertList = error.error.data;
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId] = error.error;
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].isAPIError = false;
          }
          else {
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId] = error;
            this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].isAPIError = true;
          }
        },
      })
  }


  /**
   * Below method filters the alerts that are supposed to not to be displayed
   * if call is SL2/SL3 and display the count of such alerts
   * @author :Pooja - story CCR1-4465
   */
filterAlertListIfLocked(){
  this.showLockedAlertMsg = false;
  this.noOfLockedAlerts = 0;
  let cloneAlertList = Object.assign([],this.alertList);
  if(this.isLiveCall && this.rootScope.activeCustTab.authenticateStatus != Constants.FULLY_SECURED){
    this.alertList = _.filter(cloneAlertList, function (currentObject) {
      return currentObject.secured != true;
    })
    
    if(cloneAlertList && this.alertList && ((cloneAlertList.length - this.alertList.length) > 0)){
      this.noOfLockedAlerts = cloneAlertList.length - this.alertList.length; 
      this.showLockedAlertMsg = true;
    }
    else{
      this.showLockedAlertMsg = false;
    }
   }


   if (this.loadingFromWrapUpPage && this.newAlertId) {
    /**Since in wrapuppage only those alert will be displayed which will be  unreviewed */
    this.alertList = _.filter(this.alertList, function (currentObject) {
      return currentObject.isReviwed != true;
    })
  }
 }

  /** 
  * reviewUnreview() -- calling method to make alert reviwed & unreveiwed.
  * alertId - passing alert id  as a parameter.
  * @author :Amarjeet Kumar
  */
  reviewUnreview(alertId) {
    let alert = this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]?.data.find(x => x.runtimeAlertId == alertId)
    if (this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId]) {
      if (alert?.isReviwed)
        this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].data.find(x => x.runtimeAlertId == alertId).isReviwed = false;
      else
        this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab.customerSessionId].data.find(x => x.runtimeAlertId == alertId).isReviwed = true;
    }
  }

  /** 
 * trackItem() -- updating alert list in case of addition or creation.
 * @author :Amarjeet Kumar
 */
  public trackItem(index: number, alert) {
    return alert.runtimeAlertId;
  }

  /** 
 * createAlert -- calling CreateAlertComponent component for creating Alerts.
 * @author :Amarjeet Kumar
 */
  // createAlert() {
  //   this.dialog.open(CreateAlertComponent, {
  //     panelClass: 'interaction-history-dialog',
  //     backdropClass: 'custom-overlay',
  //     id: 'createAlert'
  //   });
  // }
  openCreateAlert() {
    this.rootScope.openCreateAlertDialog = true;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog' , true]);
  }

  closeCreateAlert() {
    this.rootScope.openCreateAlertDialog = false;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog' , false]);
  }

  enableAlertEdit(alert) {
    // console.log("alert ",alert)
    if ((alert?.alertType == Constants.MANUAL_ALERT) && (alert?.authorAdId == this.rootScope.lanId || this.rootScope.batchAlertData.isBatchAlertAccess)) {
      return true;
    }
    return false;
  }

  onEditCancelClick(alert) {
    alert['enableAlertEdit'] = !alert['enableAlertEdit'];
    alert['displaySaveAlertErrMsg'] = false;
    let clonedObj = Object.assign({}, alert);
    alert['editTitle'] = clonedObj.headline;
    alert['editDesc'] = clonedObj.detail;
  }

  updateAlert(alert) {
    console.log("updateAlert alert", alert)
    let clonedObj = Object.assign({}, alert);
    alert.headline = clonedObj?.editTitle;
    alert.detail = clonedObj?.editDesc;
  }

  onEditSaveClick(alert) {

    let reqBody = { 'title': alert.editTitle, 'details': alert.editDesc };
    this.displaySaveAlertErrMsg = false;
    this.apiService.saveEditAlertData(alert?.runtimeAlertId, reqBody)
      .subscribe(
        (data: any) => {
          console.log("data", data)
          this.updateAlert(alert);
          alert['displaySaveAlertErrMsg'] = false;
          alert['enableAlertEdit'] = false;
        },
        (error) => {
          console.log("Error in saving alert data !!!", error);
          this.saveAlertFailMsg = Constants.SAVE_ALERT_FAILURE_MSG;
          alert['displaySaveAlertErrMsg'] = true;
          // alert['enableAlertEdit'] = !alert['enableAlertEdit'] ;
        });
  }

  editAlert(alert) {
    alert['enableAlertEdit'] = true;
  }

  openAccordian(alert) {
    let data = this.custAlertsService.alertListDataMap[this.rootScope.activeCustTab?.customerSessionId]?.data;
   
    if (data) {
      data.forEach(element => {
        if (element.runtimeAlertId == alert.runtimeAlertId) {
          element.isOpen = true;
        } else {
          element.isOpen = false;
        }
      });
    }
  }

  closeAccordian(alert) {
    let data = this.custAlertsService?.alertListDataMap[this.rootScope.activeCustTab?.customerSessionId]?.data;
    if (data) {
      data.forEach(element => {
        if (element.runtimeAlertId == alert.runtimeAlertId) {
          element.isOpen = false;
        }
      });
    }
  }


  viewExpiredAlerts() {
    this.rootScope.activeCustTab.viewExpiredAlert = true;
  }
 
}